<div class="h-100">
    <h1 mat-dialog-title>Quiz</h1>
    <div>
        @if (!quizFinished && questions.length > 0) {
            <app-question [question]="questions[current]" (saved)="onAnswerSaved($event)"> </app-question>
            <p class="mt-2 text-muted">Vraag {{ current + 1 }} van {{ questions.length }}</p>
        }
        @if (quizFinished) {
            <app-quiz-stats
                [questions]="questions"
                [answers]="answers"
                (showClose)="onShowClosed($event)"
                (countdown)="setCountdownValue($event)"></app-quiz-stats>
        }
    </div>
    <div mat-dialog-actions align="end">
        @if (quizFinished) {
            <button [disabled]="!showClose" (click)="close()" mat-raised-button>
                {{ countdownValue > 0 && !showClose ? countdownValue : 'Sluiten' }}
            </button>
        }
    </div>
</div>
